import Map from "./map.container";

export default Map;
